<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" icon="el-icon-plus" @click="add">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      :allBtnWidth="allBtnWidth" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="isdisplay" slot-scope="params">
        <MySwitch :data="params.params" :activeValue="`1`" :inactiveValue="`0`" @onToggle="toggleDisplay"></MySwitch>
      </template>
    </Table>

    <FormDialog ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'agencyconfig',
      delUrl: 'del',
      breadcrumb: [
        { name: "系统设置" },
        { name: "维护机构配置" },
      ],
      formCtrl: [
        {
          label: "",
          keyName: "name",
          placeholder: "请填写机构名称",
          type: "text",
        },
      ],
      cols: [
        { keyName: "name", label: "机构名称" },
        // { keyName: "sort", label: "排序" },
        { keyName: "is_display", label: "是否显示", slot: 'isdisplay' },
        { keyName: "created_at", label: "添加时间" },
      ],
      allBtnWidth: '100px',
      btns: [
        {
          ...this.editBtn,
          cb: (data) => {
            // console.log(data)
            this.getItem(data)
            this.showDialog()
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      title: '添加',
      viewMode: false,
      mform: { name: undefined },
      mrules: {
        name: [
          {
            required: true,
            message: '请填写机构名称',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "机构名称",
          keyName: "name",
          err: "请填写机构名称",
          type: "text",
        },
        // {
        //   label: "排序",
        //   keyName: "sort",
        //   err: "请填写排序",
        //   type: "number",
        //   unit: "数字越大排序越靠前",
        // },
        {
          label: "是否显示",
          keyName: "is_display",
          type: "radio",
          options: [
            { label: '是', value: 1 },
            { label: '否', value: 0 },
          ],
        },
      ],
    };
  },
  methods: {
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const obj = { ...v }
          obj.open = v.is_display + ''
          return obj
        })
      }
      // console.log(this.tableData)
    },
    toggleDisplay({ id, name, is_display }) {
      console.log(id)
      let display = (is_display === 1 ? 0 : 1)
      let url = `${this.baseUrl}/addedu`;
      const params = {
        userid: this.user.id,
        id,
        name,
        is_display: display,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '修改成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    add() {
      delete this.mform.id
      this.mform = {
        name: undefined,
        is_display: 1,
      }
      this.title = '添加'
      this.showDialog()
    },
    getItem({ id, name, is_display, sort }) {
      this.mform = {
        ...this.mform,
        id,
        name,
        sort,
        is_display,
      }
      this.title = '修改'
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .dialog {
  .el-form {
    padding-right: 0 !important;

    .el-form-item .el-form-item__content .content {
      display: block;

      .unit {
        line-height: 30px;
        margin: 0 auto;
        font-size: 12px;
        color: #FF6756;
      }
    }

    .el-input {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}
</style>